import { CaixaService } from './../../../service/caixa/caixa.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { MatDialog } from '@angular/material/dialog';
import { DetalhesSolicitacaoComponent } from 'app/components/solicitacao/detalhes-solicitacao/detalhes-solicitacao.component';


@Component({
  selector: 'app-auditoria-caixa',
  templateUrl: './auditoria-caixa.component.html',
  styleUrls: ['./auditoria-caixa.component.scss']
})
export class AuditoriaCaixaComponent implements OnInit {

  public caixaId;
  public rgCaixa;
  public loading = true;
  public auditoria: any[] = [];
  public auditoriaMigrate: any[] = [];
  public caixaMigrada = false;
  dataSource = new MatTableDataSource<any[]>([]);
  displayedColumns = ['ocorrencia', 'detalhe', 'usuario', 'data'];
  dataSourceMigrate = new MatTableDataSource<any[]>([]);
  displayedColumnsMigrate = ['ocorrencia', 'usuario', 'data'];

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<AuditoriaCaixaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private caixaService: CaixaService) { }

  ngOnInit() {
    this.caixaId = this.data.caixaId;
    this.rgCaixa = this.data.rgCaixa;
    //this.getAuditoria(this.caixaId);
    this.rastreabilidadeCaixa(this.caixaId);
  }

  rastreabilidadeCaixa(caixaId) {
    this.caixaService.rastreabilidadeCaixa(caixaId).subscribe(data => {
      const size = data.length;
      if (size > 0) {
        this.caixaMigrada = false;
        console.log(data);
        this.auditoria = data;
        this.dataSource = new MatTableDataSource(this.auditoria);
        this.loading = false;
      } else {
        this.rastreabilidadeCaixaMigrada(caixaId);
      }
      // console.log(this.auditoria);
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  showOperacionavel(valor: string) {
    if (valor!=null) {
      if (!valor.includes('class')) {
        return true;
      }
      return false;
    }
   return false;
  }

  rastreabilidadeCaixaMigrada(caixaId) {
    this.caixaService.rastreabilidadeCaixaMigrada(caixaId).subscribe(data => {
      console.log(data.length);
      this.caixaMigrada = true;
      this.auditoriaMigrate = data;
      this.dataSourceMigrate = new MatTableDataSource(this.auditoriaMigrate);
      this.loading = false;
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  auditoriaCaixa(solicitacaoId) {
    const dialogRef = this.dialog.open(DetalhesSolicitacaoComponent, {
      width: '100%',
      data: {numeroSolic: solicitacaoId}
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(`The dialog was closed - ${result}`);
      // console.log(result);
    });
  }

  relatorioAuditoria() {
    const caixa = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(this.caixaId), 'pcdoc').toString());
    window.open(`relatorio-auditoria-caixa/${caixa}`,
    '_blank',
    'location=yes,height=570,width=520,scrollbars=yes,status=yes'); // Open new window
  }

  goToSolicitacao(solicitacaoId) {
    const solicitacaoIdCrypto = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(solicitacaoId), 'pcdoc').toString());
    this.goToLink(`solicitacao/${solicitacaoIdCrypto}`);
  }

  goToLink(url: string){
    window.open(url, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes'); // Open new window
  }

  getAuditoria(caixaId) {
    this.caixaService.auditoriaCaixa(caixaId).subscribe(data => {
      this.auditoria = data;
      this.dataSource = new MatTableDataSource(this.auditoria);
      // console.log(this.auditoria);
      this.loading = false;
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/auditoria-caixa/auditoria-caixa.component.ts